import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, reactive, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { mainBodyList, mainBodyDetail } from '@/api/overseasSales/customerCenter'
import type { MainBodyParams } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuMainBody' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
// 主题状态枚举
const mainBodyStatusEnum = [
  { value: 0, label: t('mainBody.mainBodyStatus0') },
  { value: 1, label: t('mainBody.mainBodyStatus1') },
  { value: 2, label: t('mainBody.mainBodyStatus2') },
  { value: 3, label: t('mainBody.mainBodyStatus3') },
  { value: 4, label: t('mainBody.mainBodyStatus4') },
  { value: 5, label: t('mainBody.mainBodyStatus5') },
  { value: 6, label: t('mainBody.mainBodyStatus6') }
]

const tableRef = ref()
const queryForm = reactive<MainBodyParams>({ customer: {} })
const columns = computed(() => [
  { title: t('mainBody.customerNumber'), dataIndex: ['customer', 'customerNumber'] },
  { title: t('mainBody.customerName'), dataIndex: ['customer', 'customerName'] },
  { title: t('mainBody.cosId'), dataIndex: ['customer', 'cosId'] },
  { title: t('mainBody.customerCode'), dataIndex: 'customerCode' },
  { title: t('mainBody.accountCode'), dataIndex: 'accountCode', headerQuestion: t('mainBody.accountCodeDesc') },
  { title: t('mainBody.signBodyName'), dataIndex: 'signBodyName', headerQuestion: t('mainBody.signBodyNameDesc') },
  {
    title: t('mainBody.serviceBodyName'),
    dataIndex: 'serviceBodyName',
    headerQuestion: t('mainBody.serviceBodyNameDesc')
  },
  {
    title: t('mainBody.bodyContactName'),
    dataIndex: 'contactName',
    cosType: 'mask',
    headerQuestion: t('mainBody.contactNameDesc'),
    width: 150
  },
  {
    title: t('mainBody.bodyPhoneNumber'),
    dataIndex: 'phoneNumber',
    cosType: 'mask',
    headerQuestion: t('mainBody.phoneNumberDesc'),
    width: 145
  },
  {
    title: t('mainBody.signBodyBalanceList'),
    dataIndex: 'signBodyBalanceList',
    headerQuestion: t('mainBody.signBodyBalanceListDesc'),
    width: 200
  },
  { title: t('mainBody.totalQuota'), dataIndex: 'totalQuota', headerQuestion: t('mainBody.totalQuotaDesc') },
  { title: t('mainBody.allTotal'), dataIndex: 'allTotal', headerQuestion: t('mainBody.allTotalDesc'), minWidth: 130 },
  {
    title: t('mainBody.accountCycleTypeStr'),
    dataIndex: 'accountCycleTypeStr',
    headerQuestion: t('mainBody.accountCycleType')
  },
  {
    title: t('mainBody.reconciliationCycleTypeStr'),
    dataIndex: 'reconciliationCycleTypeStr',
    headerQuestion: t('mainBody.reconciliationCycleType')
  },
  {
    title: t('mainBody.signBusinessTypeStr'),
    dataIndex: 'signBusinessTypeStr',
    headerQuestion: t('mainBody.signBusiness')
  },
  {
    title: t('mainBody.contractedBusinessStr'),
    dataIndex: 'contractedBusinessStr',
    headerQuestion: t('mainBody.contractedBusinessDesc'),
    minWidth: 130
  },
  {
    title: t('mainBody.registerAreaCode'),
    dataIndex: 'registerAreaCode',
    headerQuestion: t('mainBody.registerAreaCodeDesc'),
    width: 160
  },
  {
    title: t('mainBody.signBodyType'),
    dataIndex: 'type',
    dicData: [
      { value: 'C101', label: t('mainBody.C101') },
      { value: 'C102', label: t('mainBody.C102') }
    ],
    headerQuestion: t('mainBody.typeDesc')
  },
  {
    title: t('mainBody.signBodyStatus'),
    dataIndex: 'signBodyStatus',
    headerQuestion: t('mainBody.signBodyStatusDesc'),
    dicData: mainBodyStatusEnum
  },
  { title: t('mainBody.examineTime'), dataIndex: 'examineTime', headerQuestion: t('mainBody.examineTimeDesc'), width: 190 },
  {
    title: t('mainBody.sellerName'),
    dataIndex: ['customer', 'sellerName'],
    headerQuestion: t('mainBody.sellerNameDesc'),
    minWidth: 130
  },
  { title: t('mainBody.sellerRegion'), dataIndex: ['customer', 'sellerRegion'], key: 'sellerRegion', minWidth: 190 }
])

// 检测 URL 是否带有查询参数，有则使用
const route = useRoute()
const queryCustomerCode = computed(() => route.query.customerCode as string)
onBeforeMount(() => {
  if (queryCustomerCode.value) queryForm.customerCode = queryCustomerCode.value
})

const getList = (queryForm: MainBodyParams, callBack: (res: any) => void) => {
  mainBodyList(queryForm).then((res) => {
    callBack(res)
  })
}

// 获取详情信息
const showMask = (record: any, callBack: (res: any) => void) => {
  mainBodyDetail({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[8] || (_cache[8] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosOFbuMainBody"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('mainBody.customerNumber')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customer.customerNumber,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customer.customerNumber) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('mainBody.customerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customer.customerName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customer.customerName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('mainBody.cosId')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customer.cosId,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customer.cosId) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('mainBody.signBodyName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.signBodyName,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.signBodyName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('mainBody.customerCode')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerCode,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.customerCode) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('mainBody.accountCode')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.accountCode,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.accountCode) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.department')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_ofbu",
                        ids: queryForm.customer.sellerRegionList,
                        "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.customer.sellerRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('mainBody.sellerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.customer.seller,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.customer.seller) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: ""
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_ofbu",
                taskType: "412",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'ofbu_main_body_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, text }) => [
              (column.dataIndex === 'signBodyBalanceList')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(text?.map((item) => `${item.currencyCode}：${item.quota}`).join('、')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.key === 'sellerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 1,
                    appId: "cos_ofbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})